import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_BUSINESS_TRANSACTION } from "../../../config/api";

export const getBusinessTransactions = createAsyncThunk(
  "getBusinessTransactions/get",
  async () => {
    try {
      const { data } = await Client({
        method: "GET",
        path: API_GET_BUSINESS_TRANSACTION,
      });

      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
    }
  }
);
